export const useAppEnv = () => {
  const appEnv = useRuntimeConfig().public.appEnv

  return {
    isStaging: appEnv === 'staging',
    isProduction: appEnv === 'production',
    appEnv,
  }
}
